module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.dataReady) ? _c('div', {
    class: ['article', _vm.post.acf_preview.class]
  }, [_c('header', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [(_vm.post.categories) ? _c('div', {
    staticClass: "type news"
  }, [_vm._v(_vm._s(_vm.post.categories[0].name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.post.date)))])]), _vm._v(" "), _c('h2', {
    staticClass: "h2--smaller"
  }, [_vm._v(_vm._s(_vm.removeAccents(_vm.post.title.rendered)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "post-content"
  }, [(_vm.post.featured_image) ? _c('div', {
    staticClass: "post-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.post.featured_image,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.post.content.rendered)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [
    [_vm._l((_vm.blocks), function(block, index) {
      return [_c(block.acf_fc_layout, {
        key: index,
        tag: "component",
        attrs: {
          "blockdata": block
        }
      })]
    })]
  ], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-socials"
  }, [_c('ul', {
    staticClass: "socials-light opacity-full"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": 'https://www.facebook.com/sharer/sharer.php?u=' + _vm.post.link
    }
  }, [_c('div', {
    staticClass: "fb-grey-icon"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": 'https://twitter.com/home?status=' + _vm.post.link
    }
  }, [_c('div', {
    staticClass: "tw-grey-icon"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": 'https://www.linkedin.com/shareArticle?mini=true&url=' + _vm.post.link
    }
  }, [_c('div', {
    staticClass: "in-grey-icon"
  })])])])]), _vm._v(" "), (_vm.relatednewsids) ? _c('div', {
    staticClass: "related-news"
  }, [_c('h2', [_vm._v("Related News")]), _vm._v(" "), _c('div', {
    staticClass: "posts"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row no-margin wrapper"
  }, _vm._l((_vm.relatednews), function(post, index) {
    return (index < _vm.posttoshow) ? _c('div', {
      key: index,
      staticClass: "row-element col-l-6 col-m-12 col-s-12"
    }, [_c('router-link', {
      staticClass: "post small",
      attrs: {
        "tag": "a",
        "to": {
          path: '/' + post.pure_taxonomies.categories[0].slug + '/' + post.slug
        }
      }
    }, [_c('div', {
      staticClass: "row no-margin"
    }, [_c('div', {
      staticClass: "image row-element col-l-6 col-m-6 col-s-12"
    }, [_c('div', {
      staticClass: "bg",
      style: ({
        'background-image': 'url( ' + post.better_featured_image.source_url + ' )'
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "row-element col-l-6 col-m-6 col-s-12"
    }, [_c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "sub-title"
    }, [_c('div', {
      class: ['type', post.pure_taxonomies.categories[0].category_nicename]
    }, [_vm._v(_vm._s(post.pure_taxonomies.categories[0].name))]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.formatDate(post.date)))])]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(post.title.rendered))])])])])])], 1) : _vm._e()
  }), 0)])]), _vm._v(" "), (_vm.showmorebtn) ? _c('div', {
    staticClass: "button"
  }, [_c('a', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        return _vm.showMore()
      }
    }
  }, [_vm._v("show me more")])]) : _vm._e()])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36549ca6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PostPreview.vue
// module id = 327
// module chunks = 0